import { SV2UserContext } from '@caju-beneficios/sponsor-v2-lib'
import { AuthManager } from '@caju-beneficios/sponsor-v2-lib/dist/lib/auth'

import * as React from 'react'
import { useHistory } from 'react-router-dom'

export interface LoginPageProps {
  children?: any
}

export function LoginPage(_: LoginPageProps) {
  const hasAuthInfo = !!AuthManager.getAuthInfo()?.token
  const { update } = React.useContext(SV2UserContext)
  const { push } = useHistory()

  React.useEffect(() => {
    (async () => {
      if (!hasAuthInfo) {
        await AuthManager.login()
        update()
      }

      push('/')
    })()
  }, [hasAuthInfo, push, update])

  // ---------------------------------------------
  // Transformations
  // ---------------------------------------------
  // Render

  return null
}
